export enum RequiredStartStep {
    SpokenLanguages = 'spokenLanguages',
    UserAgreement = 'userAgreement',
}
